import { sendLog, slice } from './logs.slice';
export { sendLog };
export default slice.reducer;
